import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Button from "@/components/button";
import Modal from "@/components/common-modal/modal";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";

export function RescheduleDetails({meetingId, setBtnPopup, meetingDetails}) {

  return (
    <Modal
    type="info"
      closeModal={()=> setBtnPopup(false)}
      heading={`Reschedule Details`}
      className={`RequestMore mt20`}
      innerContent={
        <>
          <div className={PageStyle.RequestDetails}>
           <h4>You have requested following time for interview:</h4>

           <h5 className={PageStyle.RequestDetails__gridauto}>Duration: <span>{meetingDetails.details.duration} </span></h5>

        </div>
        </>
      }

      />
  )

}
